<template>
    <div class="comprehensiveResources">
        <!--学科资源-->
        <div class="containers-wrap-21qT_">
            <div>
                <div class="header-17E6S"><div class="title-9Nnt6">综合素养视频</div></div>
                <div class="subject-video-2hQ77">
                    <div class="right-2OM8e">
                        <div class="lz-tab-filter delFloat">
                            <ul class="lz-tab-filter-content">
                                <li v-for="(item,index) in literacyCategoryList"
                                    :class="literacyCId===item.id?'activelvz text-white':''"
                                     @click="selectType(item.id)"
                                    :key="index" class="lz-tab-filter-li ">
                                    <el-button>
                                        {{item.title}}
                                    </el-button>
                                </li>
                            </ul>
                        </div>
                        <div class="spin-container position-relative">
                            <div v-show="albumList.length>0&&!albumListLoading">
                                <div class="summary-2eq9G">共<i>{{totalItem}}</i>个视频</div>
                                <div class="list-6gZG9">
                                    <div class="comp-group-video-1t4s2 item-2gRzS" v-for="item in albumList" :key="item.albumId">
                                        <div class="info-19Iyl">
                                            <div class="display-li margin-right">
                                                <img src="" v-lazy="item.coverImg" :key="item.coverImg" alt="" class="logo-143cK"/>
                                            </div>
                                            <div class="detail-2MDwS display-li">
                                                <div class="title-3YYvN tg-11UAd">
                                                    {{item.name}}
                                                </div>
                                                <div class="meta-JP7Sl"><span>主讲老师：</span><span class="val-3E71N">{{item.teacherName}}</span>
                                                </div>
                                                <div class="meta-JP7Sl"><span>播放：</span><span class="val-3E71N">{{item.playTimes}}</span>
                                                </div>
                                                <!--                                                    <div class="meta-JP7Sl"><span>评分：</span><span-->
                                                <!--                                                            class="val-3E71N">9.17</span>-->
                                                <!--                                                    </div>-->
                                            </div>
                                            <div class="right-2goiB display-li">
                                                <div class="a-btn-2ZcKP alignCenter d-flex justifyContentCenter" @click="wholePackage(item,'add')" v-show="!item.hasPackage"><i class="el-icon-plus"></i> 整包加入作业篮</div>
                                                <div class="a-btn-2ZcKP alignCenter d-flex justifyContentCenter remove" v-show="item.hasPackage" @click="wholePackage(item)"><i class="el-icon-minus"></i> 整包移除作业篮</div>
                                            </div>
                                        </div>
                                        <div class="list-37wyr" :class="item.hideList||item.videoList.length<=2?'item-1wKlbShow':''">
                                            <div class="item-1wKlb delFloat" v-for="itemSon in item.videoList" :key="itemSon.videoId">
                                                <a class="tit-2_HWD" href="javaScript:;">{{itemSon.videoName}}</a>
                                                <div class="float-right rightBox">
                                                    <div class="add-btn-A2KX6" v-show="!itemSon.hasAdded" @click="aSection(item.albumId,itemSon,'add')"><i class="el-icon-plus"></i> 加入作业篮</div>
                                                    <div class="remove-btn-3N0OC" v-show="itemSon.hasAdded" @click="aSection(item.albumId,itemSon)"><i class="el-icon-minus"></i> 移除作业篮</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-show="item.videoList.length>2&&!item.hideList" class="view-all-2X4I3" @click="hideAlbum(item.albumId,true)"  >查看全部{{item.videoCount}}讲课程</div>
                                        <div v-show="item.videoList.length>2&&item.hideList" class="col-all-1ZjY3"  @click="hideAlbum(item.albumId,false)"  >收起全部{{item.videoCount}}讲课程</div>
                                    </div>
                                </div>
                                <el-pagination background
                                               class="text-right"
                                               layout="total, prev, pager, next, jumper"
                                               :page-size="20"
                                               :total="totalItem"
                                               :current-page.sync="currentPage"
                                               @current-change="handlerPage">
                                </el-pagination>
                            </div>
                            <empty v-show="albumList.length<1&&!albumListLoading" content="暂无内容"></empty>
                            <loading :show="albumListLoading"></loading>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import {homeworkToBasket, literacyAlbumList, literacyCategory, videoResourceDelBasket} from "../../../config";
    import {EventBus} from "../../../assets/static/global/event-bus";

    export default {
        name: "comprehensiveResources",
        data() {
            return {
                showList: true,
                hiddenList: false,
                literacyCategoryList:[],
                literacyCId:'',
                albumList: [],
                albumListLoading:false,
                activeName: 'first',
                currentPage:1,
                totalItem:0,
            }
        },
        mounted(){
          this.literacyCategory();
        },
        methods:{
            //加入作业篮及移出作业篮
            aSection(albumId,itemSon,judge){
                let resources=[
                    {
                        albumId:albumId,
                        title:itemSon.videoName,
                        resourceId:itemSon.videoId,
                        duration:itemSon.duration
                    }
                ];
                if(judge==='add'){
                    this.addVideoBar(resources);
                }else{
                    this.delVideoBar(resources);
                }
            },
            //整包移出及加入作业篮
            wholePackage(item,judge){
                let resources=[];
                for(let i=0;i<item.videoList.length;i++){
                    resources[i]={
                        albumId:item.albumId,
                        title:item.videoList[i].videoName,
                        resourceId:item.videoList[i].videoId,
                        duration:item.videoList[i].duration
                    }
                }
                if(judge==='add'){
                    this.addVideoBar(resources);
                }else{
                    this.delVideoBar(resources);
                }
            },
            //加入视频篮
            async addVideoBar(item){
                let result=await homeworkToBasket(5,'69e6d7b522fc48f7180644791954e3db',item,2);
                if(result.status){
                    EventBus.$emit('homeworkPick');
                    this.literacyAlbumList();
                }
            },
            //移出视频篮
            async delVideoBar(item){
                let result=await videoResourceDelBasket(5,'69e6d7b522fc48f7180644791954e3db',item);
                if(result.status){
                    EventBus.$emit('homeworkPick');
                    this.literacyAlbumList();
                }
            },
            handlerPage(){
                this.literacyAlbumList();
            },
            //查出综合素养分类
            async literacyCategory(){
                let result=await literacyCategory();
                if(result.status){
                    this.literacyCategoryList=result.data;
                    this.literacyCId=result.data[0].id;
                    this.literacyAlbumList();
                }
            },
            selectType(val){
                this.currentPage=1;
                this.literacyCId=val;
                this.literacyAlbumList();
            },
            //查出综合素养视频专辑
            async literacyAlbumList(){
                let result=await literacyAlbumList(5,'69e6d7b522fc48f7180644791954e3db',this.literacyCId,this.currentPage,20);
                if(result.status){
                    this.albumList=result.data.data;
                    this.totalItem=result.data.totalRecords;
                }
            }
        }
    }
</script>
<style lang="scss">
    .lz-tab-filter-li.activelvz{
        .el-button{
            span{

                color:#ffffff!important;
            }
        }
    }
</style>

<style scoped lang="scss">
    .comprehensiveResources {
        .active{
            .el-button{
                color:#ffffff;
            }
        }
        .containers-wrap-21qT_ {
            position: relative;

            .display-li {
                display: inline-block;
            }

            .lz-tab-filter {
                font-size: 14px;

                overflow: hidden;
                transition: height .3s;

                .lz-tab-filter-label {
                    color: #7c89a7;
                    line-height: 1;
                    padding: 5px 0;
                    margin-right: 17px;
                }

                .lz-tab-filter-content {

                    .lz-tab-filter-li {
                        display: inline-block;
                        margin: 0 10px 12px 0;
                        border-radius: 4px;

                        .el-button {
                            display: inline;
                            border: none;
                            background-color: transparent;
                            cursor: pointer;
                            padding: 5px 10px;
                            outline: none;
                            line-height: 1;
                        }
                    }
                }
            }

            .subject-list-7TGNw {
                padding-bottom: 12px;
                border-bottom: 1px solid #f0f0f0;


            }
            .header-17E6S {
                height: 64px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-bottom: 1px solid #e6eaf5;
                .title-9Nnt6 {
                    font-size: 16px;
                    color: #223459;
                    line-height: 24px;
                }
            }

            .subject-video-2hQ77 {

                .right-2OM8e {
                    padding: 40px 32px 0 24px;
                    margin-left: 0;

                }

            }

        }
    }

</style>

